import i18n from 'config/i18n';
import * as Yup from 'yup';

import { nullableYupNumberTransformer } from './nullableYupNumberTransformer';

export const timeBoundValuesSectionSchema = Yup.object().shape({
  code: Yup.string()
    .required(i18n.t('dutyHourTypes.validation.code.required'))
    .max(10, i18n.t('dutyHourTypes.validation.longerThanMaximum'))
    .trim('')
    .default(''),
  description: Yup.string()
    .required(i18n.t('dutyHourTypes.validation.description.required'))
    .max(100, i18n.t('dutyHourTypes.validation.longerThanMaximum'))
    .default(''),
  dccSvc: Yup.number()
    .required(i18n.t('dutyHourTypes.validation.dccSvc.required'))
    .typeError(i18n.t('dutyHourTypes.validation.dccSvc.required')),
  activityCode: Yup.string()
    .max(50, i18n.t('dutyHourTypes.validation.longerThanMaximum'))
    .default(''),
  activityCodeAlt: Yup.string()
    .max(50, i18n.t('dutyHourTypes.validation.longerThanMaximum'))
    .default(''),
  salPerc: Yup.number()
    .min(0, i18n.t('dutyHourTypes.validation.between0And1'))
    .max(1, i18n.t('dutyHourTypes.validation.between0And1'))
    .default(1)
    .typeError(i18n.t('dutyHourTypes.validation.salPerc.required')),
  salSupplPerDutyNominal: Yup.number()
    .min(0, i18n.t('dutyHourTypes.validation.greaterThanZero'))
    .nullable()
    .transform(nullableYupNumberTransformer),
  hoursPercSeparatePerc: Yup.number()
    .min(0, i18n.t('dutyHourTypes.validation.between0And1'))
    .max(1, i18n.t('dutyHourTypes.validation.between0And1'))
    .default(0),
  hoursPercSeparateJusPerc: Yup.number()
    .min(0, i18n.t('dutyHourTypes.validation.between0And1'))
    .max(1, i18n.t('dutyHourTypes.validation.between0And1'))
    .default(0),
  hoursPercComp: Yup.number()
    .min(0, i18n.t('dutyHourTypes.validation.between0And1'))
    .max(1, i18n.t('dutyHourTypes.validation.between0And1'))
    .default(0),
  hoursPercSeparateBuhPerc: Yup.number()
    .min(0, i18n.t('dutyHourTypes.validation.between0And1'))
    .max(1, i18n.t('dutyHourTypes.validation.between0And1'))
    .default(0),
  hoursPercSeparateBonusPerc: Yup.number()
    .min(0, i18n.t('dutyHourTypes.validation.between0And1'))
    .max(1, i18n.t('dutyHourTypes.validation.between0And1'))
    .default(0)
});
